// Open where you left off (Features 4, onboarding part 6), the keeping half: once a board, or a page on a doc or plan
// board, has been open a few seconds, the account keeps it as its last place, with this browser's name for it. One
// write per place settled on, never per keystroke or on a timer. The opening half is src/help/leftOff.ts, which the
// store asks as a snapshot loads; the page it picked opens here once the board draws.

import { useEffect } from "react";
import { hasPages, kindOf } from "../../shared/boardKinds";
import { openPage, useDocUi } from "../boards/doc/state";
import { keepPlace, onboarding } from "../state/onboarding";
import { currentBoard, takePendingPlace, useStore } from "../state/store";
import { deviceId } from "./leftOff";

/** How long a board or page is open before it counts as where the user is. */
const SETTLE_MS = 4000;

export function useKeepPlace() {
  const mine = useStore((s) => s.phase === "ready" && !s.guest && !!s.workspace);
  const boardId = useStore((s) => s.boardId);
  const shelved = useStore((s) => !!currentBoard(s)?.archived);
  const paged = useStore((s) => hasPages(kindOf(currentBoard(s))));
  const page = useDocUi((d) => (boardId && paged ? (d.open[boardId] ?? null) : null));
  // the page of the place a first load picked, once its board is on screen
  useEffect(() => {
    if (!mine) return;
    const p = takePendingPlace();
    if (p?.page) openPage(p.board, p.page);
  }, [mine]);
  useEffect(() => {
    if (!mine || !boardId || shelved) return;
    const t = setTimeout(() => {
      const was = onboarding().last;
      const dev = deviceId();
      if (was && was.board === boardId && (was.page ?? null) === page && was.dev === dev) return;
      keepPlace(boardId, page, dev);
    }, SETTLE_MS);
    return () => clearTimeout(t);
  }, [mine, boardId, page, shelved]);
}
